import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase'; // db import edildi
import { 
    onAuthStateChanged, 
    signInWithEmailAndPassword, 
    signOut 
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Firestore'dan veri çekmek için
import { invalidate } from '../services/dataCache';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null); // <-- YENİ: Kullanıcı profil verisi
    const [isAdmin, setIsAdmin] = useState(false); // <-- YENİ: Admin durumu
    const [loading, setLoading] = useState(true);

    // Kullanıcı giriş yaptığında Firestore'dan profilini çeken fonksiyon
    async function fetchUserProfile(user) {
        if (user) {
            try {
                const userDocRef = doc(db, 'users', user.uid);
                const docSnap = await getDoc(userDocRef);
                if (docSnap.exists()) {
                    const profileData = docSnap.data();
                    setUserProfile(profileData); // Profil verisini state'e ata
                    setIsAdmin(profileData.isAdmin || false); // Admin durumunu ata
                    return profileData;
                } else {
                    console.log("AuthContext: Kullanıcı profili bulunamadı.");
                    setUserProfile(null);
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error("AuthContext: Profil çekilirken hata:", error);
                setUserProfile(null);
                setIsAdmin(false);
            }
        } else {
            setUserProfile(null);
            setIsAdmin(false);
        }
    }
    
    // Giriş fonksiyonu (artık profil de çekiyor)
    async function login(email, password) {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        // Giriş başarılı, şimdi profili çek
        if (userCredential.user) {
            await fetchUserProfile(userCredential.user);
        }
        return userCredential;
    }

    // Çıkış fonksiyonu
    async function logout() {
        await signOut(auth);
        setCurrentUser(null);
        setUserProfile(null);
        setIsAdmin(false);
    }

    // Oturum durumunu dinle
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            invalidate(); // Oturum değişti: önceki kullanıcının önbelleği kullanılmasın
            // Önce profil, sonra kullanıcı: AdminRoute kullanıcıyı görürken
            // isAdmin de hazır olsun (aksi halde admin kısa an /home'a atılabilir)
            await fetchUserProfile(user); // Kullanıcı değiştiğinde profili çek
            setCurrentUser(user);
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    const value = {
        currentUser,
        userProfile, // <-- YENİ: Dışarıya aç
        isAdmin,     // <-- YENİ: Dışarıya aç
        login,
        logout,
        // SignUp (kayıt) fonksiyonunuz varsa o da buradadır
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
}
